import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronTriangleLeftMedium"><Path d="M14.5 6.5V17.5L8 12L14.5 6.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleLeftMedium;
